/* eslint-disable */ import { attachSingleReferenceComponent, attributeSelectionComponent, composedOfComponent, memoEval, referenceComponent, sceneEntityObjectPropertiesComponent, sceneEntityObjectRemoteMaterialOverrideComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { GrillBaseVariant, LynxWarmingDrawer } from '../model/index.js';
export const grillBaseComponents = [
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'GrillBase.$warmingDrawer', true).withEntity('GrillBase'), LynxWarmingDrawer, 'warmingDrawerId'),
    attachComponent.withComponent(composedOfComponent, '$warmingDrawer', true).withEntity('GrillBase').attach(memoEval((self)=>[
            self.$warmingDrawer?.id ?? null
        ], (id)=>({
            childEntityIds: id === null ? [] : [
                id
            ]
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('GrillBase').attach(memoEval((self)=>[
            self.$grillBodyObjectName
        ], ($grillBodyObjectName)=>({
            fileUrl: '/models/jms.glb',
            objectName: $grillBodyObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('GrillBase').attach(memoEval((self)=>[
            self.$width
        ], ($width)=>({
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: 36 * 25.4,
                    scaleOne: 60 * 25.4
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'body', true).withEntity('GrillBase').attach(memoEval((self)=>[
            self.$warmingDrawerPanelColor,
            self.$warmingDrawerPanelMetalness,
            self.$warmingDrawerPanelRoughness,
            self.$warmingDrawerPanelRoughnessMapUrl,
            self.$warmingDrawerPanelNormalMapUrl
        ], ($warmingDrawerPanelColor, $warmingDrawerPanelMetalness, $warmingDrawerPanelRoughness, $warmingDrawerPanelRoughnessMapUrl, $warmingDrawerPanelNormalMapUrl)=>({
            fileUrl: '/models/jms.glb',
            materialName: 'controlsFrontPanelMaterial',
            materialsToOverride: [
                'controlsFrontPanelMaterial'
            ],
            color: $warmingDrawerPanelColor,
            metalness: $warmingDrawerPanelMetalness,
            roughness: $warmingDrawerPanelRoughness,
            roughnessMapUrl: $warmingDrawerPanelRoughnessMapUrl,
            normalMapUrl: $warmingDrawerPanelNormalMapUrl
        }))),
    attachComponent.withComponent(attributeSelectionComponent, 'variant', true).withEntity('GrillBase').attach(memoEval((self)=>[
            self.variant
        ], (variant)=>({
            value: variant,
            options: [
                {
                    label: 'Yes',
                    value: 'WithWarmingDrawer'
                },
                {
                    label: 'No',
                    value: 'Default'
                }
            ]
        })), (state)=>{
        GrillBaseVariant.assert(state.value);
        return {
            variant: state.value
        };
    })
];

//# sourceMappingURL=grill-base.js.map